import { qs, qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import ProductTile from '@/lib/product-tile';
import navigationDots from '@/lib/navigation-dots';

const selectors = {
  productTile: '[data-product-tile]',
};

section('featured-collection', {
  onLoad() {
    this.productTiles = [];
    const sliderContainer = qs('[data-slider]', this.container);
    const slides = qsa('.featured-collection__item ', this.container);
    let dotNavigation = null;

    this.productTiles = qsa(selectors.productTile, this.container).map(tile =>
      ProductTile(tile)
    );

    import('flickity').then(({ default: Flickity }) => {
      this.slider = new Flickity(sliderContainer, {
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        wrapAround: false,
      });

      if (slides.length > 1) {
        dotNavigation = navigationDots(this.container, this.slider);

        this.slider.on('select', () => {
          dotNavigation.update(this.slider.selectedIndex);
        });
      }
    });
  },

  onUnload() {
    this.slider.destroy();
    this.productTiles.forEach(tile => tile.unload());
  },
});
